module.exports = __webpack_public_path__ + "assets/logo-dark.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-dark.png
// module id = 373
// module chunks = 0